<template>
  <MAFieldWrapper
    :label="label"
    :value="modelValue as any"
    :disabled="disabled"
    :required="required"
    :readonly="readonly"
    :placeholder="placeholder"
    :rules="rules"
  >
    <Calendar
      v-model="value"
      :view="view"
      :selection-mode="selectionMode"
      :show-icon="showIcon"
      :date-format="format"
      :min-date="min"
      :placeholder="placeholder"
      :max-date="max"
      :disabled="disabled"
      :invalid="invalid"
      :show-button-bar="showButtonBar"
      class="w-full"
    />
  </MAFieldWrapper>
</template>

<script setup lang="ts">
import Calendar from "@/volt/DatePicker.vue";
import MAFieldWrapper from "./MAFieldWrapper.vue";

const props = withDefaults(
  defineProps<{
    modelValue?: Date;
    label?: string;
    disabled?: boolean;
    required?: boolean;
    readonly?: boolean;
    invalid?: boolean;
    placeholder?: string;
    min?: Date;
    max?: Date;
    showIcon?: boolean;
    format?: string;
    rules?: Record<string, any>;
    showButtonBar?: boolean;
    view?: "month" | "year" | "date";
    selectionMode?: "single" | "multiple" | "range";
  }>(),
  {
    view: "date",
    selectionMode: "single",
    disabled: false,
    placeholder: "",
    type: "text",
  }
);

const emit = defineEmits(["update:modelValue"]);
const value = useVModel(props, "modelValue", emit);
</script>
